import { useState, useEffect } from 'react';

export function useDebounce(value: string, delay = 500) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        // Устанавливаем таймер
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        // Очищаем таймер, если значение изменилось до истечения delay
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}